import { CreateClassroomForm } from '../types';
import { StudentLoginType } from 'types/schema-generated-types';

const defaultForm: CreateClassroomForm = {
  CREATE_CLASS: {
    name: '',
    // placeholder value until organization field is finalezed
    organization: '',
    educator: '',
    schoolYear: '',
    secretCodeType: StudentLoginType.LETTER_CARDS,
    color: '#f44336',
    coeducators: []
  },
  ADD_STUDENTS: {
    students: new Array(10).fill({
      firstName: undefined,
      lastName: undefined,
      username: undefined,
      email: undefined,
      secretCode: { loginType: StudentLoginType.LETTER_CARDS, code: '' },
      gradeLevel: undefined,
      group: undefined
    })
  }
};

export default defaultForm;
